import React, { useEffect, useRef, useState } from "react";
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { isEmpty, size } from 'lodash';
import { buildPath, convertUTCToTzDate, showErrorMessage } from '../../utils/common';
import Emitter from "../../utils/Emitter";
import NoDataFound from "../../components/common/NoDataFound";
import ToolipsCustom from '../../components/ToolipsCustom';
import companylogo from "../../images/Company-logo.svg";
import { privateRoutePaths } from '@/routes/private.route.config';
import ReactPaginate from "react-paginate";
import roles from '@/constant/roles.config';
import defaultValues from '../../constant/defaultValues';
import { useAuth } from '../../AuthProvider';
import { connect } from 'react-redux';
import ProfileHistoryViewFilter from "@/pages/admin/ProfileHistoryViewFilter";
import { viewProfileAction } from "@/actions/viewProfileAction";
import { getVisitedByOthereHistory } from "@/actions/memberAction";
import { hideLoading, showLoading } from "@/actions/loaderAction";


function VisitedByOthers(props) {
   const { type } = props; 
      
  const [nodata, setNoData] = useState(false);
  const { id } = useParams();
  const companyID = id;
  const [memberList, setMemberList] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const tradeModeRef = useRef(null);
  const [limit, setLimit] = useState(6);
  const [current_page, setCurrentPage] = useState(1);
  const [searchFilterObj, setSearchFilterObj] = useState({
    filter_val: null,
    findWhom: "All",
    selected_country: null,
    startDate: null,
    endDate: null
  });
  const { IMAGE_PATH } = defaultValues;
  const [tableKey, setTableKey] = useState(0);
  const { isEndUser, isDemoUser, isPreKYCUser, user, isViewer } = useAuth();


  const fetchCompanyProfile = async (id) => {

    await props.viewCompany(id).then(async (response) => {

      if (response.status) {

        if (!isEmpty(response.data)) {
          setCurrentData(response.data[0]);
          if (searchParams.get("history") === null) {
            if (response.data[0]?.trade_mode_type !== "LOG_PTR") {
              tradeModeRef.current = "BUYER_SUPPLIER";
              Emitter.emit("TRADE_MODE_TYPE", "BUYER_SUPPLIER");
            } else {
              tradeModeRef.current = "LOG_PTR";
              Emitter.emit("TRADE_MODE_TYPE", "LOG_PTR");
            }
          } else {
            let l = searchParams.get("history");
            let l1 = atob(l);
            if (l1 === "LOG") {
              tradeModeRef.current = "PAID_LEAD";
              Emitter.emit("TRADE_MODE_TYPE", "PAID_LEAD");
            }
          }


        }
      }
    }).catch((err) => {
      console.log("Error ============ ", err);

    });
  }

  const getProfileViewMembers = async (limit, current_page, filterObj) => {
    setNoData(false);
    await props.showLoading();
    await props.getVisitedByOthereHistory(companyID, limit, current_page, filterObj).then((response) => {

      // console.log("Response Visited By others profile ==== ", response);

      if (size(response.data) === 0) {
        setNoData(true);
      }
      setMemberList(response.data);
      setPagination(response.pagination);
    }).catch((err) => {
      console.log("Error ==== ", err);
      showErrorMessage("Something went wrong");
    })
    await props.hideLoading();
  }


  const pageCount = Math.ceil(pagination.total / limit);

  useEffect(() => {
    fetchCompanyProfile(companyID);
    getProfileViewMembers(limit, current_page, searchFilterObj);
  }, []);

  const setProfileViewByOtherFilters = (newState) => {
    props.showLoading();
    newState.table_search = "";
    newState.current_page = 1;
    setCurrentPage(1);
  };

  const filterApplyOnProfileViewByOther = (filterObj) => {
    setSearchFilterObj(filterObj);
    getProfileViewMembers(limit, current_page, filterObj);
    setTableKey((prev) => prev + 1);
    props.hideLoading();
  };

  useEffect(() => {
    // Emitter.on("FILTER_MEBER_VIEW_HISTORY", filterApplyOnProfileViewByOther);
    // Emitter.on("SET_FILTER_MEBER_VIEW_HISTORY", setProfileViewByOtherFilters);
    // return () => {
    //   Emitter.off("FILTER_MEBER_VIEW_HISTORY", filterApplyOnProfileViewByOther);
    // };

    const SET_EVENT    = `SET_FILTER_MEBER_VIEW_HISTORY_${type}`;
    const FILTER_EVENT = `FILTER_MEBER_VIEW_HISTORY_${type}`;

    Emitter.on(SET_EVENT, setProfileViewByOtherFilters);
    Emitter.on(FILTER_EVENT, filterApplyOnProfileViewByOther);

    return () => {
      Emitter.off(SET_EVENT, setProfileViewByOtherFilters);
      Emitter.off(FILTER_EVENT, filterApplyOnProfileViewByOther);
    };
    
  },[]);


  const handlePageClick = (event) => {
    getProfileViewMembers(limit, event.selected + 1, searchFilterObj);

  };

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  // console.log("memberList === ", memberList);

  return (
    <div className='row'>

      <div className='col-12'>
        <ProfileHistoryViewFilter type={type}
          getCountryList={props.getCountryList} />
      </div>
      <div className='col-12'>
        {memberList.length === 0 ? (

          <div className='card'>
            <NoDataFound />
          </div>
        ) : (
          <div className='list-wrape'>
            {memberList.map((item, index) => {
              //console.log("item in map ==== ", item);
              const m = item?.viewer_member?.[0];
             // console.log("m ==== ", m);

              if (!m) return null;

              return (
                <div key={item.id || index} className='list'>
                  <div className='left-date-label'>
                    <div className='label-date'>
                      <span className='date'>{convertUTCToTzDate(item.created_at, 'Etc/UTC', 'YYYY-MM-DD')}</span>
                      <span className='time'>{convertUTCToTzDate(item.created_at, 'Etc/UTC', 'hh:mm A')} <ToolipsCustom subtitle="Universal Time Coordinated" title={"UTC"}></ToolipsCustom></span>
                    </div>
                  </div>
                  <div className='right-data-wrape'>
                    <div className='card'>
                      <div className='user-pad'>
                        <div className='left-img'>
                          <div className="viewprofile-img-effect">
                            <img src={m && m.company_logo ? IMAGE_PATH.BASE_URL + '/company_logo/' + m.company_logo : companylogo} alt="" height={150} className='' />
                          </div>
                        </div>
                        <div className='right-detail'>
                          <div className='head-text'>
                            <h3>
                              {m.company_name && m.id ? (
                                <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: m.id })}`} target="_blank">{(!isEmpty(m.company_name) ? m.company_name : "-")}</Link>
                              ) : (
                                <span>{(!isEmpty(m.company_name) ? m.company_name : "-")}</span>
                              )}
                              <span className='sub-text'>
                                {(!isEmpty(m.member_city?.name) ? m.member_city.name + ', ' : "")}
                                {(!isEmpty(m.country?.name) ? m.country.name : "-")}
                              </span>
                            </h3>
                            <p>
                              <b>Orex ID</b> {(!isEmpty(m.member_unique_number) ? m.member_unique_number : "-")}
                            </p>
                          </div>
                          <div className='data-wrape'>
                            <p>
                              <span>Contact Person</span> {(!isEmpty(m.salutation) ? m.salutation + " " : "") + (!isEmpty(m.first_name) ? m.first_name + " " : "") + (!isEmpty(m.last_name) ? m.last_name : "")}
                            </p>
                            <p>
                              <span>Designation</span> {(!isEmpty(m.designation) ? m.designation : "-")}
                            </p>
                            <p>
                              <span>Email</span> {(!isEmpty(m.email) ? m.email : "-")}
                            </p>
                            {/* <p>
                                    <span>Country</span>{(!isEmpty(m.country?.name) ? m.country.name : "-")}
                                  </p>
                                  <p>
                                    <span>City</span>{(!isEmpty(m.member_city?.name) ? m.member_city.name : "-")}
                                  </p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}


          </div>
        )}

        <div className="d-flex justify-content-between inquiry-pagination mt-5">
          {pagination.total > 0 && (<>
            <p>
              showing <b>{pagination.from}</b> to <b>{pagination.to}</b> of <b>{pagination.total}</b>
            </p>

            <ReactPaginate
              key={tableKey}
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="<"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link prev"
              nextClassName="page-item"
              nextLinkClassName="page-link next"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </>
          )}
        </div>
      </div>
    </div>
  );
  
}
const mapStateToProps = state => {

  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    viewCompany: (companyID) => dispatch(viewProfileAction(companyID)),
    getVisitedByOthereHistory: (companyID, limit, current_page, filterObj) => dispatch(getVisitedByOthereHistory(companyID, limit, current_page, filterObj)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(VisitedByOthers);